{
  "version": 1,
  "asset_id": "93bb0c40-d49c-48dc-8604-3544bd04a90d",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/93bb0c40-d49c-48dc-8604-3544bd04a90d/sleeve-gastrectomy-v2-1536.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/93bb0c40-d49c-48dc-8604-3544bd04a90d/sleeve-gastrectomy-v2-1536.jpg",
  "original_filename": "sleeve-gastrectomy-v2-1536.jpg",
  "size": 164032,
  "content_type": "image/jpeg",
  "created_at": "2026-09-25T13:06:50Z"
}
